import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 0C4.03902 0 0 4.03902 0 9C0 13.961 4.03902 18 9 18C13.961 18 18 13.961 18 9C18 4.03902 13.961 0 9 0ZM9 16.2439C5.00488 16.2439 1.7561 12.9951 1.7561 9C1.7561 5.00488 5.00488 1.7561 9 1.7561C12.9951 1.7561 16.2439 5.00488 16.2439 9C16.2439 12.9951 12.9951 16.2439 9 16.2439Z",
  fill: "#4B291D"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.00288 3.73047C8.42337 3.73047 7.94922 4.20462 7.94922 4.78413V10.2763C7.94922 10.8558 8.42337 11.33 9.00288 11.33C9.58239 11.33 10.0565 10.8558 10.0565 10.2763V4.78413C10.0565 4.20462 9.58239 3.73047 9.00288 3.73047Z",
  fill: "#4B291D"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.0565 13.2138C10.0565 13.7957 9.5848 14.2675 9.00288 14.2675C8.42096 14.2675 7.94922 13.7957 7.94922 13.2138C7.94922 12.6319 8.42096 12.1602 9.00288 12.1602C9.5848 12.1602 10.0565 12.6319 10.0565 13.2138Z",
  fill: "#4B291D"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }